import { FC } from 'react'
import { Divider } from 'antd'
import { Alert, ImportButton } from '../../../ui'
import style from './style.m.less'
import { Edit, Search, Trash } from '../../../../assets/icons'
import { EUserType } from '../../../../constants/approval'

export interface IIPGO {
    first_name: string
    last_name: string
    middle_name: string
    personal_inn: string
    ogrn: string
    user_type: EUserType
    uid?: string
}

interface ISelectedIPGO {
    label: string
    selectedGO?: IIPGO
    required?: boolean
    onRemoveClick(): void
    onEditClick(): void
    onSearchClick(): void
    onManualEditClick(): void
}

const SelectedIPGO: FC<ISelectedIPGO> = ({
    label,
    selectedGO,
    required,
    onRemoveClick,
    // onEditClick,
    onSearchClick,
    onManualEditClick,
}) => {
    return (
        <>
            <div className={style.inputWrapper}>
                <div className={style.label}>
                    {label}
                    {required && <span className={style.star}>*</span>}
                </div>
                {selectedGO && (
                    <Alert
                        className={style.resultLegalAlert}
                        message={
                            <div className={style.alertTitleWrapper}>
                                <span className={style.alertTitle}>
                                    ИП {selectedGO.last_name} {selectedGO.first_name}{' '}
                                    {selectedGO.middle_name}
                                </span>
                                <div className={style.alertIconWrapper}>
                                    {/* <span className={style.icon} onClick={onEditClick}>
                                        <Edit />
                                    </span> */}
                                    <span className={style.icon} onClick={onRemoveClick}>
                                        <Trash />
                                    </span>
                                </div>
                            </div>
                        }
                        description={
                            <>
                                <span className={style.alertDetail}>
                                    ИНН - {selectedGO.personal_inn}
                                </span>
                                <Divider type="vertical" />
                                <span className={style.alertDetail}>ОГРН - {selectedGO.ogrn}</span>
                            </>
                        }
                        type="info"
                        showIcon={false}
                    />
                )}

                {!selectedGO && (
                    <div className={style.linkWrapper}>
                        <ImportButton
                            value="Найти в системе"
                            icon={<Search />}
                            onClick={onSearchClick}
                        />
                        <Divider type="vertical" />
                        <ImportButton
                            value="Заполнить вручную"
                            icon={<Edit />}
                            onClick={onManualEditClick}
                        />
                    </div>
                )}
            </div>
        </>
    )
}

export default SelectedIPGO
